import * as actionTypes from "../action-types";
import { getInitialSteps, getInitialAppState, addConsultantStep, removeConsultantStep } from "../StoreHelpers";
import moment from "moment";

const appReducer = (state = getInitialAppState(), { type, payload }) => {
    switch (type) {
        case actionTypes.LOADING_FAIL:
            return {
                ...state,
                splashWait: {
                    ...state.splashWait,
                    show: false,
                },
            };

        case actionTypes.RESET_SPLASH_WAIT:
            return {
                ...state,
                splashWait: {
                    ...state.splashWait,
                    show: null,
                },
            };

        case actionTypes.SET_COMPLETED:
            return {
                ...state,
                completed: payload,
            };

        case actionTypes.SET_CURRENT_STEP:
            return {
                ...state,
                curStep: { ...payload.curStep },
                activeStep: payload.activeStep,
                stepDirection: payload.stepDirection,
            };

        case actionTypes.ON_NEED_LOGIN_POPUP:
            return {
                ...state,
                showNeedLogin: payload,
            };

        case actionTypes.ON_SUBMIT_PAYMENT_PLAN:
            return {
                ...state,
                showConfirmPayment: true,
                repaymentOption: {
                    ...state.repaymentOption,
                    input: {
                        ...state.repaymentOption.input,
                        ...payload,
                    }
                }
            };

        case actionTypes.ON_CONFIRM_PAYMENT:
            return {
                ...state,
                showConfirmPayment: false
            };

        case actionTypes.ON_CANCEL_CONFIRM_PAYMENT:
            return {
                ...state,
                showConfirmPayment: false,
            };

        case actionTypes.SET_PAYMENT_METHOD:
            return {
                ...state,
                payment: {
                    ...state.payment,
                    input: {
                        ...state.payment.input,
                        paymentMethod: payload,
                    },
                },
            };

        case actionTypes.ON_AGREE_TO_TERMS:
            return {
                ...state,
                payment: {
                    ...state.payment,
                    agreeToTerms: payload,
                },
            };

        case actionTypes.ON_CONSENT:
            return {
                ...state,
                payment: {
                    ...state.payment,
                    consent: payload,
                },
            };

        case actionTypes.ON_AGREE_DEBIT_TERMS:
            return {
                ...state,
                payment: {
                    ...state.payment,
                    agreeDebitTerms: payload,
                },
            };
        
        case actionTypes.ON_AGREE_ARRANGE_FUND:
            return {
                ...state,
                payment: {
                    ...state.payment,
                    agreeArrangeFund: payload,
                },
            };

        case actionTypes.API_PAYMENT_PLAN_SUCCESS:
            return {
                ...state,
                payment: {
                    ...state.payment,
                    data: {
                        ...state.payment.data,
                        ...payload
                    },
                },
            };

        case actionTypes.API_PAYMENT_SUCCESS:
            return {
                ...state,
                payment: {
                    ...state.payment,
                    status: 'success',
                    data: {
                        ...state.payment.data
                    },
                },
            };
        
        case actionTypes.API_PAYMENT_FAIL:
            return {
                ...state,
                payment: {
                    ...state.payment,
                    status: 'fail',
                    data: {
                        ...state.payment.data
                    },
                },
            };
        
        case actionTypes.PAYWAY_TRANSACT_ERROR:
            return {
                ...state,
                payment: {
                    ...state.payment,
                    status: 'invalid'
                },
            };

        case actionTypes.ON_CANCEL_AUTHENTICATION:
            return {
                ...state,
                showNeedLogin: false,
            };

        case actionTypes.VALID_STATUS_EMAIL:
            return {
                ...state,
                formUpdate: {
                    ...state.formUpdate,
                    input: {
                        ...state.formUpdate.input,
                        isValidEmail: payload,
                    }
                }
            };


        case actionTypes.VALID_STATUS_MOBILE:
            return {
                ...state,
                formUpdate: {
                    ...state.formUpdate,
                    input: {
                        ...state.formUpdate.input,
                        isValidMobile: payload,
                    }
                }
            };

        case actionTypes.SET_SPLASH_WAIT:
            return {
                ...state,
                splashWait: {
                    ...state.splashWait,
                    ...payload,
                },
            };

        case actionTypes.SET_PAYMENT_FRAME:
            return {
                ...state,
                payment: {
                    ...state.payment,
                    input: {
                        ...state.payment.input,
                        paymentFrame: payload,
                    },
                },
            };

        case actionTypes.SET_PAYMENT_TOKEN:
            return {
                ...state,
                payment: {
                    ...state.payment,
                    input: {
                        ...state.payment.input,
                        singleUseToken: payload,
                    },
                },
            };
        
        case actionTypes.ON_PROCEED_RESET:
            return {
                ...getInitialAppState()
            };

        default:
            return state;
    }
};

export default appReducer;
